import { defineComponent as p, openBlock as o, createElementBlock as e, mergeProps as i, unref as n, renderSlot as u, createElementVNode as l, createCommentVNode as g } from "vue";
import { useScalarIcon as m } from "../hooks/useScalarIcon.js";
const Z = { key: 0 }, M = { key: 1 }, f = { key: 2 }, k = { key: 3 }, S = { key: 4 }, c = { key: 5 }, h = {
  name: "ScalarIconEgg"
}, _ = /* @__PURE__ */ p({
  ...h,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const C = r, { bind: a, weight: s } = m(C);
    return (d, t) => (o(), e("svg", i({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, n(a)), [
      u(d.$slots, "default"),
      n(s) === "bold" ? (o(), e("g", Z, t[0] || (t[0] = [
        l("path", { d: "M190,57.34C171.06,29,147.88,12,128,12S84.94,29,66,57.34C46.94,86,36,120.46,36,152a92,92,0,0,0,184,0C220,120.46,209.06,86,190,57.34ZM128,220a68.07,68.07,0,0,1-68-68c0-61.12,46.19-116,68-116s68,54.88,68,116A68.07,68.07,0,0,1,128,220Z" }, null, -1)
      ]))) : n(s) === "duotone" ? (o(), e("g", M, t[1] || (t[1] = [
        l("path", {
          d: "M208,152a80,80,0,0,1-160,0C48,88,96,24,128,24S208,88,208,152Z",
          opacity: "0.2"
        }, null, -1),
        l("path", { d: "M186.66,59.56C168.47,32.29,146.54,16,128,16S87.53,32.29,69.34,59.56C50.7,87.54,40,121.23,40,152a88,88,0,0,0,176,0C216,121.23,205.3,87.54,186.66,59.56ZM128,224a72.08,72.08,0,0,1-72-72c0-27.69,9.72-58.15,26.66-83.56C97.19,46.64,115.41,32,128,32s30.81,14.64,45.34,36.44C190.28,93.85,200,124.31,200,152A72.08,72.08,0,0,1,128,224Z" }, null, -1)
      ]))) : n(s) === "fill" ? (o(), e("g", f, t[2] || (t[2] = [
        l("path", { d: "M216,152a88,88,0,0,1-176,0c0-30.77,10.7-64.46,29.34-92.44C87.53,32.29,109.46,16,128,16s40.47,16.29,58.66,43.56C205.3,87.54,216,121.23,216,152Z" }, null, -1)
      ]))) : n(s) === "light" ? (o(), e("g", k, t[3] || (t[3] = [
        l("path", { d: "M185,60.67C167.18,34,145.87,18,128,18S88.82,34,71,60.67C52.57,88.32,42,121.61,42,152a86,86,0,0,0,172,0C214,121.61,203.43,88.32,185,60.67ZM128,226a74.09,74.09,0,0,1-74-74c0-28.08,9.84-58.94,27-84.67C96.11,44.65,114.56,30,128,30s31.89,14.65,47,37.33c17.15,25.73,27,56.59,27,84.67A74.09,74.09,0,0,1,128,226Z" }, null, -1)
      ]))) : n(s) === "regular" ? (o(), e("g", S, t[4] || (t[4] = [
        l("path", { d: "M186.66,59.56C168.47,32.29,146.54,16,128,16S87.53,32.29,69.34,59.56C50.7,87.54,40,121.23,40,152a88,88,0,0,0,176,0C216,121.23,205.3,87.54,186.66,59.56ZM128,224a72.08,72.08,0,0,1-72-72c0-27.69,9.72-58.15,26.66-83.56C97.19,46.64,115.41,32,128,32s30.81,14.64,45.34,36.44C190.28,93.85,200,124.31,200,152A72.08,72.08,0,0,1,128,224Z" }, null, -1)
      ]))) : n(s) === "thin" ? (o(), e("g", c, t[5] || (t[5] = [
        l("path", { d: "M128,20C92.87,20,44,86.52,44,152a84,84,0,0,0,168,0C212,86.52,163.13,20,128,20Zm0,208a76.08,76.08,0,0,1-76-76c0-28.46,10-59.73,27.33-85.78C94.81,43,113.91,28,128,28s33.19,15,48.67,38.22C194,92.27,204,123.54,204,152A76.08,76.08,0,0,1,128,228Z" }, null, -1)
      ]))) : g("", !0)
    ], 16));
  }
});
export {
  _ as default
};
